var handlerReferences = {
  $selectContainer: $('.institutes-dropdown > div'),
  $institutes: $('.institutes-buttons a'),
  $referenceContainers: $('.reference-content-container'),
  init: function() {
    var self = this;
    this.$institutes.on('click', function(e) {
      e.preventDefault();
      var $link = $(e.target).closest('a');
      $link.parents('.institutes-buttons').find('a').removeClass('is-active');
      $link.addClass('is-active');
      // khusus utk small, karena institut yg ga aktif dihide
      var $logo = $link.find('.rounded-image');
      $logo.height($logo.width());
      // select institute
      var $institute = $('.reference-content-container #institute-'+$link.data('institute'));
      handlerNavigation.scrollIntoView($institute);
    });
    this.$institutes.find('.button').on('click', function(e) {
      if (Foundation.MediaQuery.only('small')) {
        e.stopPropagation();
        self.$selectContainer.toggleClass('hide');
      }
    });
    $('body').on('click', function() {
      self.$selectContainer.addClass('hide');
    });
    this.$selectContainer.find('div[data-institute]').on('click', function() {
      self.$institutes.filter('[data-institute="'+$(this).data('institute')+'"]').trigger('click');
    })
  },
};

jQuery(document).ready(function($) {
  if ($('body.page-template-page-references').length > 0) {
    // jump ke riset tertentu kalo ada parameter url nya
    var researchId = getUrlParameter('research_id');
    handlerReferences.init();
    if (researchId) {
      handlerNavigation.scrollIntoView(handlerReferences.$referenceContainers.find("#research-"+researchId));
    }
  }
});
